import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import AxiosInstance from "../../api/AxiosInstance";

export const fetchProducts = createAsyncThunk(
  "products/fetchProducts",
  async ({ page = 1, limit = 12 }, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(`product?page=${page}&limit=${limit}`);

      if (response.data?.data && response.data?.pagination) {
        const { totalPages, currentPage, limit: countPerPage, hasNextPage, hasPrevPage } =
          response.data.pagination;

        return {
          items: response.data.data,
          totalPages,
          currentPage,
          countPerPage,
          hasNextPage,
          hasPrevPage,
        };
      }

      return rejectWithValue("Invalid response from server.");
    } catch (error) {
      console.error("Fetch Products Error:", error);
      if (error.response) {
        return rejectWithValue(
          `Server error: ${error.response.status} ${error.response.statusText}`
        );
      } else if (error.request) {
        return rejectWithValue("No response from API server.");
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const productSlice = createSlice({
  name: "products",
  initialState: {
    items: [],
    filteredItems: [],
    loading: false,
    error: null,
    searchQuery: "",
    currentPage: 1,
    totalPages: 1,
    countPerPage: 12,
    hasNextPage: false,
    hasPrevPage: false,
  },
  reducers: {
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
      const query = action.payload.toLowerCase();
      state.filteredItems = state.items.filter((item) =>
        item.PROD_NAME?.toLowerCase().includes(query)
      );
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setCountPerPage: (state, action) => {
      state.countPerPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.items || [];
        state.filteredItems = action.payload.items || [];
        state.totalPages = action.payload.totalPages;
        state.currentPage = action.payload.currentPage;
        state.countPerPage = action.payload.countPerPage;
        state.hasNextPage = action.payload.hasNextPage;
        state.hasPrevPage = action.payload.hasPrevPage;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch products.";
      });
  },
});

export const { setSearchQuery, setCurrentPage, setCountPerPage } =
  productSlice.actions;
export default productSlice.reducer;
